// Centralised route constants for the treasury wallets-directory
// module. Backend route renames are a one-file change.

const WALLETS_DIRECTORY = '/api/admin/treasury/wallets'

export const WALLETS_DIRECTORY_ENDPOINT_PATHS = {
  LIST: WALLETS_DIRECTORY,
} as const
